import * as React from 'react';
import {IntlProvider} from 'react-intl';
import {Provider, connect} from 'react-redux';
import {history, store} from './redux/store';
import PublicRoutes from './router';
// import {} from 'redux-persist/integration/react';

const DashApp = () => (


    <Provider store={store}>
        <PublicRoutes history={history}/>
    </Provider>


);

// export default connect(state => ({
//     currentAppLocale: AppLocale[state.Language.language.locale]
// }))(DashApp);

export default DashApp;




// WEBPACK FOOTER //
// ./src/dashApp.tsx